import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';
import { DailyRental, Site } from '../planning';
import { User } from '../users';

export interface RentalType {
    _id: string;
    designation: string;
    codeProC: string;
    crudStatus: number;
    displayOrder?: number;
}

export interface MonthlyRentalType extends RentalType {
    dailyRentalTypesByDate: {
        date: string;
        daily: { dailyRentalType: DailyRental; user: User; site: Site }[];
    }[];
}

export interface GetMonthlyRentalTypeParams {
    date: string;
}

export interface MonthlyRentalTypesResponse {
    data: MonthlyRentalType[];
    message: string;
}

export const getMonthlyRentalTypes = async (params: GetMonthlyRentalTypeParams): Promise<MonthlyRentalTypesResponse> => {
    try {
        const response: AxiosResponse<MonthlyRentalTypesResponse> = await apiClient.get('/rental-types/monthly/' + params.date);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
